import React from 'react';

import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { TooltipPosition } from 'ui-components/components/tooltip/tooltip-position';

import { DropdownMenuItemContent } from './dropdown-menu-item-content/dropdown-menu-item-content';
import { emptyArray } from 'ui-components/default-props/empty';
import { MessageDescriptorPropType } from '../../prop-types/intl';

const OtherActionMenu = ({ otherActions = emptyArray, containerClassName = '' }) => {
  const intl = useIntl();
  return (
    <div className={containerClassName}>
      {otherActions.map(({ nameDescriptor, actionHandler, isDisabled, disabledReason, pendoTrackingId }, index) => {
        const dropdownMenuItemName = intl.formatMessage(nameDescriptor);

        return (
          <DropdownMenuItem
            key={index}
            disabled={isDisabled}
            disabledTooltipMessage={disabledReason?.id ? intl.formatMessage(disabledReason) : undefined}
            disabledTooltipMessagePosition={TooltipPosition.Right}
            id={`${nameDescriptor.id}-${index}`}
            onClick={actionHandler}
            pendoTrackingId={pendoTrackingId}
            title={dropdownMenuItemName}
            useAdvancedTruncationTitleLogic
          >
            <DropdownMenuItemContent disabledReason={disabledReason}>{dropdownMenuItemName}</DropdownMenuItemContent>
          </DropdownMenuItem>
        );
      })}
    </div>
  );
};

OtherActionMenu.propTypes = {
  otherActions: PropTypes.arrayOf(
    PropTypes.shape({
      nameDescriptor: MessageDescriptorPropType,
      actionHandler: PropTypes.func,
      disabled: PropTypes.bool,
      disabledReason: MessageDescriptorPropType,
    }),
  ),
  containerClassName: PropTypes.string,
};

export default OtherActionMenu;
